import { twMerge } from "tailwind-merge";
import type { CartProduct } from "../../../models/cart-product";
import type { OrderItem } from "../../../models/order-item";

type ProductNameProps = {
  product: CartProduct | OrderItem;
  className?: string;
  quantityClassName?: string;
};

export const ProductName = ({ product, className, quantityClassName }: ProductNameProps) => {
  const productNameClasses = twMerge("text-[16px] text-grey-700", className);
  const quantityClasses = twMerge("text-[17px] font-bold", quantityClassName);
  const quantity = "quantity" in product ? product.quantity : 1;

  return (
    <span className={productNameClasses}>
      {product.name}
      {quantity > 1 && (
        <>
          {" "}
          <span className={quantityClasses}>×{quantity}</span>
        </>
      )}
    </span>
  );
};
